<template>
    <!--客户成套设备订单详情-->
  <div class="content">
    <div class="center">
      <div class="detail-top flex-row">
        <div class="title">当前状态：
            {{orderInfo.orderSatus == 0 ? '未确认提交': orderInfo.orderSatus == 1 ? '待厂商确认' : orderInfo.orderSatus == 2 ? '待平台签约'
              : orderInfo.orderSatus == 3 ? '待客户支付租金' : orderInfo.orderSatus == 24 ? '待厂商支付服务费'
                  : orderInfo.orderSatus == 34 ? '待平台确认服务费': orderInfo.orderSatus == 5 ? '待厂商安装验收'
                      : orderInfo.orderSatus == 6 ? '待客户用电完成' : orderInfo.orderSatus == 7 ? '已完成'
                          : orderInfo.orderSatus == 8 ? '已完成(已评价)' : orderInfo.orderSatus == 70 ? '中止订单' : '其他'}}
        </div>


        <el-button
          class="btn"
          plain
          v-show="
            statusId == 0 || statusId == 1 || statusId == 2 || statusId == 3
          "
          @click="quxiao()"
          >中止订单</el-button>
        <el-button class="btn" plain v-show="statusId == 6" @click="songdian()"
          >确认送电</el-button>
        <el-button class="btn" plain @click="customerServer"
          >联系客服</el-button>
      </div>
      <!-- 设备列表 -->
      <div class="detail-box" v-for="(item, index) in eqList" :key="index">
        <div class="device-box flex-row">
          <div class="device-img">
            <img :src="$imgUrl + item.pictureUrl" />
          </div>
          <div class="device-info">
            <p class="name">{{ item.title }}</p>
            <div class="price-box flex-row">
              <span>价格</span>
              <span class="price"
                >￥{{ item.duration_price }}/{{ duration }}月</span
              >
            </div>
            <p class="tips">
              *价格说明<br />
              以上价格标注为参考价，具体价格您根据需求下单后待双方协商
            </p>
          </div>
          <div class="info">
            <div class="title">
              <p>设备信息</p>
            </div>
            <div class="info-intro">
              <div class="item">
                <label>提供人姓名</label> <span>{{ item.userName }}</span>
              </div>
              <div class="item">
                <label>设备类型</label> <span>{{ item.typeName }}</span>
              </div>
              <div class="item">
                <label>设备容量</label> <span>{{ item.volume }}</span>
              </div>
              <div class="item">
                <label>设备地点</label>
                <span
                  >{{ item.provinceName }} {{ item.cityName }}
                  {{ item.countyName }}</span
                >
              </div>
              <div class="item">
                <label>输出电压</label> <span>{{ item.voltage }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="intro-box">
          <div class="title">配套线路：</div>
          <div class="service-plan flex-row">
            <div class="item">
              <label>架空线路：</label>
              <span>{{ item.priceGears && item.priceGears.jkxl }}元/档</span>
              <span v-if="item.dsbjkxl"> * {{ item.dsbjkxl }}</span>
            </div>
            <div class="item">
              <label>电缆线路：</label>
              <span>{{ item.priceGears && item.priceGears.dlxl }}元/米</span>
              <span v-if="item.dsbdlxl"> * {{ item.dsbdlxl }}</span>
            </div>
            <div class="item">
              <label>单杆：</label>
              <span>{{ item.priceGears && item.priceGears.dgxl }}元/个</span>
              <span v-if="item.dsbdgxl"> * {{ item.dsbdgxl }}</span>
            </div>
            <div class="" style="margin-left: 20px">
              标准档距：50米/档，现场勘查时不足50米按一档计；相关设备以及线路占地用户负责协调
            </div>
          </div>
        </div>
      </div>

      <!-- 用电信息 -->
      <div class="card use-card">
        <div class="card-tit">用电信息</div>
        <div
          class="list"
          :class="statusId == 9 || statusId == 11 ? 'bottom' : ''"
        >
            <div class="item">
                <span class="item-tit">工程名称：</span>{{ orderInfo.projectname  }}
            </div>
          <div class="item">
            <span class="item-tit">地址：</span>{{ uaddress }}
          </div>
          <div class="item">
            <span class="item-tit">租赁期限：</span>{{ duration }}月
          </div>
          <div class="item">
            <span class="item-tit">开始时间：</span>{{ orderInfo.startTime | formatDate }}
          </div>
          <div class="item">
            <span class="item-tit">结束时间：</span>{{ entTime | formatDate }}
          </div>
<!--            <div class="item">-->
<!--                <span class="item-tit">平台签约时间：</span>{{ orderInfo.qrhtTime }}-->
<!--            </div>-->
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="card order-card">
        <div class="card-tit">订单信息</div>
        <el-button class="btn detailBtn" plain @click="viewAccount">查看往来账目</el-button>
        <div class="list">
            <div class="item"><span class="item-tit">订单编号：</span>{{ orderInfo.orderNo }}</div>
            <div class="item"><span class="item-tit">设备租金：</span>¥{{ orderInfo.advance }}</div>
            <div class="item"><span class="item-tit">服务费：</span>¥{{ orderInfo.serviceFee }}</div>
            <!-- <div class="item"><span class="item-tit">确认合同：</span>{{ form.qrhtTime  }}</div> -->
            <!--            <div class="item"><span class="item-tit">开始时间：</span>{{ form.startTime }}</div>-->
            <div class="item"><span class="item-tit">申请时间：</span>{{ orderInfo.addTime }}</div>
            <div class="item"><span class="item-tit">厂商确认时间：</span>{{ orderInfo.ptqrzjTime }}</div>


            <template v-if="orderInfo.orderSatus!=70">
                <div class="item"><span class="item-tit">平台签约时间：</span>{{ orderInfo.qrhtTime }}</div>
            <div class="item"><span class="item-tit">用电用户支付租金时间：</span>{{ orderInfo.khzfTime }}</div>
            <div class="item"><span class="item-tit">厂商确认收款租金时间：</span>{{ orderInfo.csqrszTime }}</div>
            <div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ orderInfo.cszffufTime }}</div>
            <div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ orderInfo.ptqrsxfTime }}</div>
            <div class="item"><span class="item-tit">厂商安装验收时间：</span>{{ orderInfo.azysTime }}</div>
            <div class="item"><span class="item-tit">设备送电确认时间：</span>{{ orderInfo.gateTime }}</div>
            </template>

            <div class="item"><span class="item-tit" v-if="orderInfo.orderSatus==70">订单中止时间：</span>{{ orderInfo.zzddTime }}</div>
<!--          <div class="item"><span class="item-tit">申请时间：</span>{{ orderInfo.addTime }}</div>-->
<!--          <div class="item"><span class="item-tit">用电用户支付租金时间：</span>{{ order.payTime }}</div>-->
<!--          <div class="item"><span class="item-tit">平台确认租金时间：</span>{{ order.confirmTime }}</div>-->
<!--          <div class="item"><span class="item-tit">订单编号：</span>{{ order.series }}</div>-->
<!--          <div class="item"><span class="item-tit">厂商支付平台（技术）服务费时间：</span>{{ order.payServiceTime }}</div>-->
<!--          <div class="item"><span class="item-tit">平台确认平台（技术）服务费时间：</span>{{ order.confirmServiceTime }}</div>-->
<!--          <div class="item"><span class="item-tit">设备租金：</span>¥{{ order.rent }}</div>-->
<!--          <div class="item"><span class="item-tit">安装验收时间：</span>{{ order.installTime }}</div>-->
<!--          <div class="item"><span class="item-tit">确认送电时间：</span>{{ order.powerTime }}</div>-->
<!--          <div class="item"><span class="item-tit">服务费：</span>￥{{ orderInfo.serviceFee }}</div>-->
<!--          <div class="item"><span class="item-tit">平台结算厂商租金时间：</span>{{ order.settleTime }}</div>-->
<!--          <div class="item"><span class="item-tit">厂商确认收款租金时间：</span>{{ order.receiveTime }}</div>-->
        </div>

      </div>

<!--      &lt;!&ndash; 续费 &ndash;&gt;-->
<!--      <div class="card file-card stopCard" id="jumptop" v-if="xufeiFlag">-->
<!--        <div class="card-tit">续费信息</div>-->
<!--        <div class="renew-box">-->
<!--          <div-->
<!--            class="renew-item"-->
<!--            :class="['item', { active: renewIndex == index }]"-->
<!--            v-for="(item, index) in renewList"-->
<!--            :key="index"-->
<!--            @click="monthHandle(item, index)"-->
<!--          >-->
<!--            <p class="month">{{ item.day }}月</p>-->
<!--            <p class="renew">￥{{ item.price }}</p>-->
<!--            <p class="renew" v-if="orderInfo.serviceFeeRefund == 2">-->
<!--              {{ item.priceStr }}-->
<!--            </p>-->
<!--            <i class="el-icon-check active-icon"></i>-->
<!--          </div>-->
<!--          &lt;!&ndash; <div class="num-box">-->
<!--						<div class="num-tit">单杆：<span class="num-one">{{dgxl}}元/个</span></div>-->
<!--						<el-input-number v-model="form.dgxlNum" placeholder="请输入内容" @change="handleChange" :min="0"-->
<!--							:max="1">-->
<!--						</el-input-number>-->
<!--					</div>-->
<!--					<div class="num-box">-->
<!--						<div class="num-tit">架空线路：<span class="num-one">{{jkxl}}元/档</span></div>-->
<!--						<el-input-number v-model="form.jkxlNum" placeholder="请输入内容" @change="handleChange" :min="1"-->
<!--							:max="100">-->
<!--						</el-input-number>-->
<!--					</div> &ndash;&gt;-->
<!--        </div>-->
<!--        <div class="file-warn">*提交后需要厂家核定价格。</div>-->
<!--        <div class="btnGroup">-->
<!--          <div class="btn scoreBtn" @click="xufei()">确定</div>-->
<!--          <div class="btn cancelBtn" @click="xufeiFlag = false">取消</div>-->
<!--        </div>-->
<!--      </div>-->

      <!-- 终止订单协议 -->
<!--      <div-->
<!--        class="card file-card"-->
<!--        v-if="orderInfo.orderSatus == 50 && orderInfo.status > 2"-->
<!--      >-->
<!--        <div class="card-tit">终止订单协议</div>-->
<!--        <div class="file-warn">*请查看终止协议，没有意义后平台退款金额。</div>-->
<!--        <div class="file-box">-->
<!--          <img src="./bg.png" class="pdfIcon" alt="" />-->
<!--          <div class="file-info">-->
<!--            <div class="file-name">终止协议</div>-->
<!--            <div class="file-date">（{{ orderInfo.sctkxyTime || "无" }}）</div>-->
<!--          </div>-->
<!--          <div style="margin-left: 150px; font-size: 20px">-->
<!--            <span>退款用电用户费用：￥{{ orderInfo.yonghufy }}</span>-->
<!--            <span style="margin-left: 50px"-->
<!--              >支付厂商费用：￥{{ orderInfo.changshangfy }}</span-->
<!--            >-->
<!--          </div>-->
<!--        </div>-->
<!--        <div-->
<!--          class="btn download"-->
<!--          style="cursor: pointer"-->
<!--          @click="openLink(orderInfo.tkUrl)"-->
<!--        >-->
<!--          下载-->
<!--        </div>-->
<!--        <div-->
<!--          class="btnGroup"-->
<!--          v-if="orderInfo.status == 3 && orderInfo.statuson != 1"-->
<!--        >-->
<!--          <div class="btn scoreBtn" @click="tongYiTkxy">同意</div>-->
<!--          <div class="btn cancelBtn" @click="$router.go(-1)">取消</div>-->
<!--        </div>-->
<!--      </div>-->
      <!-- 支付信息 -->
      <div class="card file-card" v-show="status == 3">
        <div class="card-tit">支付信息</div>
        <div class="file-warn">
          *请给厂商支付租金。
        </div>
        <div class="btnGroup">
          <div
            class="btn scoreBtn"
            @click="uploadPaySuccess(4)"
            v-if="status == 3"
          >
            确认付款
          </div>


<!--          <div-->
<!--            class="btn scoreBtn"-->
<!--            @click="uploadPaySuccess(12)"-->
<!--            v-if="status == 12"-->
<!--          >-->
<!--            提交-->
<!--          </div>-->
<!--          <div-->
<!--            class="btn scoreBtn"-->
<!--            @click="uploadPaySuccess(12)"-->
<!--            v-if="status == 8"-->
<!--          >-->
<!--            提交-->
<!--          </div>-->
          <div class="btn cancelBtn" @click="$router.go(-1)">取消</div>
        </div>
      </div>
      <!-- 评价列表 -->
      <div
        class="card file-card"
        v-show="(status == 8 || status == 60) && orderInfo.proposal"
      >
        <div class="card-tit borderB">评价</div>
        <div class="evaluate-lists">
          <div
            class="evaluate-box evaluate-item"
            v-for="item in pinglunList"
            :key="item.id"
          >
            <div class="user-line items-center">
              <img :src="$imgUrl + item.heading" class="userImg" alt="" />
              <div class="user-name">{{ item.masterName }}</div>
              <div class="score-line">
                <el-rate
                  v-model="item.fractionUser"
                  disabled
                  show-score
                  text-color="#ff9900"
                  score-template=""
                >
                </el-rate>
              </div>
              <div class="user-name time">{{ item.updateTime }}</div>
            </div>
            <div class="evaluate">{{ item.proposal }}</div>
            <div class="imgs" v-if="item.proposalUrl != null">
              <!-- <img :src="$imgUrl + item1" class="evaluate-img" alt=""
								v-for="item1 in item.proposalUrl.split(',')" :key="item1"> -->
              <el-image
                :src="$imgUrl + item1"
                class="fileImg evaluate-img"
                :preview-src-list="[$imgUrl + item1]"
                v-for="item1 in item.proposalUrl.split(',')"
                :key="item1"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 评价 -->
      <div class="card file-card" v-if="status == 7">
        <div class="card-tit">评价</div>
        <div class="evaluate-box">
          <img :src="$imgUrl + orderInfo.heading" class="userImg" alt="" />
          <el-input
            type="textarea"
            resize="none"
            :rows="4"
            placeholder="请输入内容"
            v-model="pjneirong"
          >
          </el-input>
          <div class="upload-box">
            <p class="upload-add">图片上传</p>
            <el-upload
              :action="$uploadUrl"
              list-type="picture-card"
              :multiple="false"
              :on-success="handleCertSuccess1"
              :on-remove="handleRemove1"
              :accept="$imgExt"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>
          <div class="score-box">
            <div class="score-tit">综合评分</div>
            <div class="score-line">
              <el-rate v-model="value1"></el-rate>
            </div>
          </div>
          <div class="btn scoreBtn" @click="pingjia()" style="cursor: pointer">
            评价
          </div>
        </div>
      </div>

      <!-- 厂商回复内容 -->
      <div class="card" v-if="orderInfo.orderSatus == 8 && orderInfo.estimate">
        <div class="card-tit borderB">回复内容</div>
        <div class="evaluate-lists">
          <div class="evaluate-box evaluate-item">
            <div
              style="display: flex; justify-content: start; align-items: center"
            >
              <div class="user-name">{{ orderInfo.companyName }}</div>

              <div class="user-name time" style="margin-left: 20px">
                {{ orderInfo.cshfTime }}
              </div>
            </div>
            <div class="evaluate" style="margin: 20px 0">
              {{ orderInfo.estimate }}
            </div>
            <div class="imgs" v-if="orderInfo.factoryPingJiaImg != null">
              <el-image
                :src="$imgUrl + item1"
                class="fileImg evaluate-img"
                :preview-src-list="[$imgUrl + item1]"
                v-for="item1 in orderInfo.factoryPingJiaImg.split(',')"
                :key="item1"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <account-dialog ref="accountDialogRef"></account-dialog>
  </div>
</template>

<script>
import AccountDialog from "./accountList.vue";
import { orderDetailApi, eqPriceListApi } from "../../http/api/ordinary.js";
import {
  equOrderDetail,
  updateOrder,
  delOrder,
  addVoucherAllApi,
} from "../../http/factory/add-eme.js";
export default {
  name: "orderDetailDevice",
  components: {
    AccountDialog,
  },
  data() {
    return {
      eqIds: [],
      eqList: [],
      xufeiFlag: false,
      stopOrderFlag: false,
      item: [],
      fileList: [],
      value1: null,
      score: 1,
      statusId: 10,
      status: "",
      statusName: "",
      textarea: "",
      // 续费
      renewVal: 1,
      renewList: [],
      renewIndex: 0,
      orderId: "",
      pictureUrl: "",
      title: "",
      price: "",
      userName: "",
      typeName: "",
      voltage: "",
      volume: "",
      address: "",
      xbxl: "",
      dlxl: "",
      jkxl: "",
      dgxl: "",
      uaddress: "",
      startTime: "",
      entTime: "",
      orderInfo: {},
      order: {
        applyTime: "2022/6/191",
        payTime: "2022/6/192",
        confirmTime: "2022/6/193",
        confirmContract: "2022/6/194",
        payServiceTime: "2022/6/195",
        confirmServiceTime: "2022/6/196",
        series: "2022/6/197",
        installTime: "2022/6/198",
        powerTime: "2022/6/199",
        rent: "2000",
        settleTime: "2022/6/19t",
        receiveTime: "2022/6/19f",
        renew: {
          applyTime: "2022/6/19",
          payTime: "2022/6/19",
          confirmTime: "2022/6/19",
          limit: "2022/6/19",
          payServiceTime: "2022/6/19",
          confirmServiceTime: "2022/6/19",
          price: "",
          settleTime: "2022/6/19",
          receiveTime: "2022/6/19",
        },
        suspend: {
          applyTime: "2022/6/19",
          reason: "2022/6/19",
          confirmTime: "2022/6/19",
        },
      },
      imageUrl: [],
      pjneirong: "",
      pjtp: "",
      duration: "",
      pinglunList: [],
      xfStstus: 0,
      voucherList: [],
      form: {
        orderSatus: null,
        userAddress: "",
        startTime: null,
        orderType: 0,
        businessId: null,
        equipmentId: null,
        advance: 0,
        dgxlNum: 0,
        dgxlPrice: 0,
        jkxlNum: 0,
        jkxlPrice: 0,
        dlxlNum: 0,
        dlxlPrice: 0,
        //月份
        month: "",
        price: 0,
      },
      accountList: [],
      htUrl: "",
    };
  },
    filters: {
        formatDate(date1) {
            let date = new Date(date1)
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');

            // 格式化为 'YYYY-MM-DD HH:mm' 的形式
            return `${year}-${month}-${day}`;
        }
    },
  created() {
    this.orderId = this.$route.query.id;
    this.getDetail();
  },
  methods: {
    xufeiFlagHandle() {
      this.xufeiFlag = true;
      window.scrollTo(0, 1200);
    },
    // 订单支付信息上传图片删除方法
    handleRemove(e, fileList) {
      console.log("shanchju", this.imageUrl);
      var a = this.imageUrl.indexOf(e.response.fileName);
      if (a > -1) {
        this.imageUrl.splice(a, 1);
        console.log("卡", this.imageUrl);
      }
    },
    // 评论图片删除方法
    handleRemove1(e) {
      console.log("删除", e.response.fileName);
      console.log("shanchju", this.fileList);
      var a = this.fileList.indexOf(e.response.fileName);
      if (a > -1) {
        this.fileList.splice(a, 1);
        console.log("卡", this.fileList);
      }
    },
    getEqPriceList() {
      eqPriceListApi({
        equipmentIds: this.eqIds.join(","),
      }).then((res) => {
        this.renewList = res;
      });
    },
    monthHandle(item, index) {
      this.renewIndex = index;
      // this.form.month = item.month,
      this.form.price = item.count;
      this.computePrice();
    },
    handleChange() {
      this.computePrice();
    },
    computePrice() {
      this.form.advance =
        this.form.price +
        this.dgxl * this.form.dgxlNum +
        this.jkxl * this.form.jkxlNum;
    },
    customerServer() {
      this.$router.push({
        path: "/service",
      });
    },
    //终止订单
    zhongzhi() {
      if (!this.textarea) {
        return this.$message("请填写终止订单原因");
      }
      updateOrder({
        id: this.orderId,
        status: 1,
        orderSatus: 50,
        terminationReason: this.textarea,
        isTerminate: this.orderInfo.orderSatus,
        // zzddTime: new Date(),
        zzddTime: this.formatTime(),
      }).then((res) => {
        this.$message({
          message: "终止订单成功",
          type: "success",
        });
        this.stopOrderFlag = false;
        this.$router.go(-1);
      });
    },
    //取消终止
    cancelStopHanle() {
      updateOrder({
        id: this.orderId,
        status: 1,
        orderSatus: 5,
        qxzhongzhi: 12,
      }).then((res) => {
        this.$message({
          message: "取消终止订单成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },
    tongYiTkxy() {
      updateOrder({
        id: this.orderId,
        // khtyxyTime: new Date(),
        khtyxyTime: this.formatTime(),
        orderSatus: 50,
        statuson: 1,
        status: this.orderInfo.statuson == 2 ? 4 : 3,
      }).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },
    stopSumbit() {
      if (this.imageUrl.length <= 0) {
        this.$message({
          message: "请上传凭证图片",
          type: "warning",
        });
        return;
      }
      let voucherDesc = "终止订单费用";
      let voucherSource = "用电客户-收款";
      let arr = [];
      for (let item of this.imageUrl) {
        arr.push({
          orderId: this.orderId,
          type: 1,
          storageAdd: item,
          voucherDesc,
          voucherSource,
        });
      }
      addVoucherAllApi({
        voucherList: arr,
      });

      let obj = {
        id: this.orderId,
        statuson: 3,
        orderSatus: 50,
        status: this.orderInfo.statuson == 4 ? 6 : 5,
        // khqrskTime: new Date(),
        khqrskTime: this.formatTime(),
      };

      updateOrder(obj).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },
    quxiao() {
      this.$confirm("您确认要中止当前订单吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
          updateOrder({
          id: this.orderId,
              orderSatus: 70,
              zzddTime: this.formatTime(),
        }).then((res) => {
          this.$message({
            message: "中止成功",
            type: "warning",
            onClose: () => {
              this.$router.back();
            },
          });
        });
      });
    },
    xufei() {
      updateOrder({
        id: this.orderId,
        status: 1,
        orderSatus: 60,
        // xftime: new Date(),
        xftime: this.formatTime(),
        xfday: this.renewList[this.renewIndex].day,
        xufeijg: this.renewList[this.renewIndex].price,
      }).then((res) => {
        this.$message({
          message: "申请续费成功",
          type: "success",
        });
        this.$router.go(-1);
      });
    },

    uploadPaySuccess(status) {
      // if (this.imageUrl.length <= 0) {
      //   this.$message({
      //     message: "请上传凭证图片",
      //     type: "warning",
      //   });
      //   return;
      // }
      // console.log('aaa', this.imageUrl);
      // return


      let voucherDesc = "";
      let voucherSource = "";
      if (status == 4) {
        voucherDesc = this.orderInfo.status == 60 ? "设备费用(续)" : "设备费用";
        voucherSource = "用电客户-支付";
      }
      let arr = [];
      for (let item of this.imageUrl) {
        arr.push({
          orderId: this.orderId,
          type: 0,
          storageAdd: item,
          voucherDesc,
          voucherSource,
        });
      }

      let obj = {};

      if (this.orderInfo.status == 60) {
        obj = {
          id: this.orderId,
          orderSatus: status,
          // xfkhzftime: new Date(),
          xfkhzftime: this.formatTime(),
        };
      } else {
        obj = {
          id: this.orderId,
          orderSatus: status,
          // khzfTime: new Date(),
          khzfTime: this.formatTime(),
        };
      }
      if(this.status == 3){
          obj = {
              id: this.orderId,
              orderSatus: 4,
              // khzfTime: new Date(),
              khzfTime: this.formatTime(),
          };
      }
        this.$confirm('您确定支付给厂商租金了吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            obj.khzfTime = this.formatTime();
            updateOrder(obj).then((res) => {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$router.go(-1);
            });

        })
    },
    pingjia() {
      if (this.fileList.length <= 0) {
        this.$message({
          message: "请上传评价图片",
          type: "warning",
        });
        return;
      }
      if (this.pjneirong == "") {
        this.$message({
          message: "请填写评价内容",
          type: "warning",
        });
        return;
      }
      if (this.value1 == 0) {
        this.$message({
          message: "请选择评分",
          type: "warning",
        });
        return;
      }
      updateOrder({
        id: this.orderId,
        proposalUrl: this.fileList.join(","),
        proposal: this.pjneirong,
        fractionUser: this.value1,
        orderSatus: 8,
      }).then((res) => {
        this.$message({
          message: "评价成功",
          type: "success",
        });
        this.getDetail();
      });
    },

    handlePictureCardPreview1(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleCertSuccess1(res, file) {
      if (res.code == 200) {
        this.fileList.push(res.fileName);
      }
    },
    songdian() {
        this.$confirm('您确定设备送电了吗', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            updateOrder({
                id: this.orderId,
                orderSatus: 7,
                // gateTime: new Date(),
                gateTime: this.formatTime(),
            }).then((res) => {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$router.go(-1);
            });
        })
    },
    handleAvatarSuccess(file) {
      console.log("2222", file);
      this.imageUrl.push(file.fileName);
    },
    viewAccount() {
      this.$refs.accountDialogRef.showDialog(this.accountList);
    },
    xiazai() {
      if (!this.htUrl) {
        return this.$message("当前合同不能下载");
      }
      window.open(this.htUrl);
    },
    //打开退款协议
    openLink(link) {
      if (!link) {
        return this.$message("当前内容不能下载");
      }
      window.open(this.$imgUrl + link);
    },
    getDetail() {
      orderDetailApi({
        id: this.orderId,
      }).then((res) => {
        this.htUrl = this.$imgUrl + res.htUrl;
        this.accountList = res.accountsList;
        this.voucherList = res.voucherList;
        this.xfStstus = res.status;
        this.statusId = res.orderSatus;
        this.status = res.orderSatus;
        this.orderInfo = res;
        // if (res.orderSatus == 0) {
        //   this.statusName = "待提交申请";
        // }
        // if (res.orderSatus == 1) {
        //   this.statusName = "待确认";
        // }
        // if (res.orderSatus == 2) {
        //   this.statusName = "待签约";
        // }
        // if (res.orderSatus == 3) {
        //   this.statusName = "待支付租金";
        // }
        // if (res.orderSatus == 4) {
        //   this.statusName = "已支付（待平台确认租金）";
        // }
        // if (res.orderSatus == 24) {
        //   this.statusName = "待厂商支付服务费";
        // }
        // if (res.orderSatus == 34) {
        //   this.statusName = "已支付服务费（待平台确认）";
        // }
        // if (res.orderSatus == 5) {
        //   this.statusName = "待安装验收";
        // }
        // if (res.orderSatus == 6) {
        //   this.statusName = "待确认送电";
        // }
        // if (res.orderSatus == 16 || res.orderSatus == 26) {
        //   this.statusName = "使用中（30天后结算租金完成订单）";
        // }
        // if (res.orderSatus == 18) {
        //   this.statusName = "待确认收款";
        // }
        // if (res.orderSatus == 7) {
        //   this.statusName = "已完成";
        // }
        // if (res.orderSatus == 8) {
        //   this.statusName = "已评价";
        // }
        // if (res.orderSatus == 50) {
        //   if (res.status == 1) {
        //     this.statusName = "终止订单（待厂商确认）";
        //   } else if (res.status == 2) {
        //     this.statusName = "终止订单（待平台确认）";
        //   } else if (res.status == 3) {
        //     if (res.statuson == 1) {
        //       this.statusName = "终止订单（待厂商确认协议）";
        //     } else {
        //       this.statusName = "终止订单（待确认协议）";
        //     }
        //   } else if (res.status == 4) {
        //     this.statusName = "已终止（退款中）";
        //   } else {
        //     this.statusName = "终止订单";
        //   }
        // }
        // if (res.orderSatus == 60) {
        //   this.statusName = "续费申请";
        // }
        this.title = res.title;
        this.userName = res.userName;
        this.typeName = res.typeName;
        this.voltage = res.voltage;
        this.volume = res.volume;
        this.address = res.provinceName + res.cityName;
        this.pictureUrl = this.$imgUrl + res.pictureUrl;
        // this.uaddress = res.uprovinceName + res.ucityName + res.ucountyName + res.uaddress
        this.uaddress = res.userAddress;
        this.duration = res.orderPro.duration;
        this.startTime = res.startTime;
        this.entTime = res.entTime;

        this.order.applyTime = res.addTime;
        this.order.payTime = res.khzfTime;
        this.order.confirmTime = res.ptqrzjTime;
        this.order.confirmContract = res.qrhtTime;
        this.order.payServiceTime = res.cszffufTime;
        this.order.confirmServiceTime = res.ptqrsxfTime;
        this.order.series = res.orderNo;
        this.order.installTime = res.azysTime;
        this.order.powerTime = res.gateTime;
        this.order.rent = res.advance;
        this.order.settleTime = res.ptjscsTime;
        this.order.receiveTime = res.csqrszTime;
        this.pinglunList = res.emergencyPowerProtectionOrders;
        //设备列表
        if (res.serviceFeeRefund == 1) {
          this.eqList = [];
          this.eqIds = [];
          let this_eqList = JSON.parse(res.equipmentList);
          this.eqList = this_eqList;
          this.eqIds.push(res.equipmentId);
        } else {
          this.eqList = [];
          this.eqIds = [];
          let this_eqList = JSON.parse(res.equipmentList);
          for (let item of this_eqList) {
            this.eqList.push({
              pictureUrl: item.pictureUrl,
              title: item.title,
              priceGears: item.priceGears,
              userName: item.userName,
              typeName: item.typeName,
              volume: item.volume,
              countyName: item.countyName,
              voltage: item.voltage,
              provinceName: item.provinceName,
              cityName: item.cityName,
              dsbdgxl: item.dsbdgxl,
              dsbjkxl: item.dsbjkxl,
              dsbdlxl: item.dsbdlxl,
            });
            console.log("item.pri", item.priceGears);
            if (!res.priceGears) {
              res.priceGears = item.priceGears;
            }
            this.eqIds.push(item.id);
          }
        }
        console.log("dfa", this.eqList);
        for (let index in this.eqList) {
          // console.log(this.eqList[index].priceGears);
          // return
          if (this.duration == 3) {
            this.eqList[index].duration_price = this.eqList[
              index
            ].priceGears.price;
          } else if (this.duration == 6) {
            this.eqList[index].duration_price = this.eqList[
              index
            ].priceGears.price1;
          } else if (this.duration == 9) {
            this.eqList[index].duration_price = this.eqList[
              index
            ].priceGears.price2;
          } else if (this.duration == 12) {
            this.eqList[index].duration_price = this.eqList[
              index
            ].priceGears.price3;
          } else {
            this.eqList[index].duration_price = 0;
          }
        }
        this.getEqPriceList();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.detail-box {
  margin-bottom: 20px;
  background: #ffffff;
  border-radius: 10px;
  padding: 20px;

  .device-box {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .device-img {
      width: 200px;
      height: 200px;
      border-radius: 10px;
      margin-right: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .device-info {
      width: 30%;

      .name {
        font-size: 0.2rem;
        color: #333333;
        line-height: 0.23rem;
        font-weight: 500;
      }

      .price-box {
        margin-top: 0.22rem;
        font-size: 0.14rem;
        color: #000000;
        line-height: 0.2rem;
        align-items: center;
        position: relative;

        .price {
          color: #ff4141;
          margin-left: 0.1rem;
        }
      }

      .tips {
        font-size: 0.13rem;
        color: #8f8f8f;
        line-height: 0.33rem;
        margin-top: 0.1rem;
      }
    }

    .info {
      width: 60%;
      border: 1px solid #f2f2f2;

      .title {
        height: 40px;
        background: #fff3ec;
        line-height: 40px;
        padding-left: 10px;

        p {
          font-size: 20px;
          color: #000000;
        }
      }

      .info-intro {
        display: flex;
        flex-wrap: wrap;

        .item {
          margin: 30px 10px;
          width: 30%;
          font-size: 15px;

          label {
            color: #afafaf;
          }

          span {
            margin-left: 20px;
            color: #000000;
          }
        }
      }
    }

    .btns {
      flex: 1;
      text-align: right;
      padding-right: 0.22rem;

      .apply {
        width: 1.07rem;
        height: 0.42rem;
        background: #fa6600;
        border-radius: 0.06rem;
        font-size: 0.14rem;
        color: #ffffff;
        line-height: 0.42rem;
        text-align: center;
        border: none;
      }

      .service {
        width: 1.07rem;
        height: 0.42rem;
        background: #ffffff;
        border-radius: 0.06rem;
        border: 1px solid #fa6600;
        font-size: 0.14rem;
        color: #fa6600;
        line-height: 0.42rem;
        text-align: center;
        margin-top: 0.2rem;
      }
    }
  }

  .intro-box {
    margin-top: 20px;

    .title {
      font-size: 0.16rem;
      color: #000000;
    }

    .service-plan {
      margin-top: 20px;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 20px;
      background: #f9f9f9;
      border-radius: 0.06rem;

      .item {
        line-height: 0;
        padding: 0.15rem 0.2rem;

        label {
          display: inline-block;
          min-width: 0.9rem;
          font-size: 0.14rem;
          line-height: 0.24rem;
          color: #aaaaaa;
          margin-right: 0.2rem;
          text-align: right;
        }

        span {
          font-size: 0.14rem;
          line-height: 0.24rem;
          color: #333333;
        }
      }
    }
  }
}

.fs16 {
  font-size: 0.16rem;
}

.fs14 {
  font-size: 0.14rem;
}

.color0 {
  color: #000;
}

.content {
  background: #f5f5f5;

  .btn {
    min-width: 0.96rem;
    background: #ffffff;
    border-radius: 0.06rem;
    font-size: 0.14rem;
    padding: 0.1rem 0.2rem;
    text-align: center;
    line-height: 0.2rem;
    color: #686868;
    border: 1px solid rgba(104, 104, 104, 0.19);
  }

  .borderB {
    border-bottom: 1px solid #f3f3f3;
  }

  .center {
    width: 15.2rem;
    margin: 0 auto;
    padding: 0.1rem 0 0.4rem;

    .detail-top {
      width: 100%;
      height: 0.82rem;
      background: #ffffff;
      border-radius: 0.1rem;
      margin-bottom: 0.1rem;
      padding: 0 0.3rem 0 0.2rem;
      box-sizing: border-box;
      align-items: center;

      .title {
        font-size: 0.18rem;
        font-weight: bold;
        color: #f6812f;
        flex: 1;
      }
    }

    .device-card {
      margin-bottom: 0.1rem;

      // 多套设备
      &.more-device {
        .card {
          margin-bottom: 0 !important;
        }

        .info-box {
          padding-top: 0.33rem !important;
        }

        .info-logo {
          height: 1.9rem !important;
          width: 1.9rem !important;
        }

        .info-main {
          display: flex;
        }

        .device-info {
          margin-top: 0 !important;
        }
      }
    }

    .card {
      margin-bottom: 0.1rem;
      background: #fff;
      border-radius: 0.06rem;
      border-bottom: 1px solid #e6e6e6;

      &:last-child {
        border-bottom: unset;
      }

      .info-box {
        padding: 0.67rem 0.33rem 0.1rem;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        position: relative;

        .msgBtn {
          position: absolute;
          right: 0.3rem;
          top: 0.6rem;
          color: #fa6600;
          border: 1px solid #fa6600;
        }

        .info-logo {
          width: 2.96rem;
          height: 2.96rem;
          margin-right: 0.2rem;

          &.more-logo {
            height: 1.9rem;
            width: 1.9rem;
          }
        }

        .info-main {
          flex: 1;

          .name {
            font-size: 0.2rem;
            font-weight: bold;
            color: #333333;
            line-height: 0.23rem;
            padding-left: 0.1rem;
          }

          .price {
            line-height: 0.25rem;
            font-size: 0.14rem;
            color: #000000;
            padding: 0.19rem 0.1rem 0.12rem;

            .num {
              font-size: 0.18rem;
              font-weight: bold;
              color: #ff4141;
              padding-left: 0.2rem;
            }
          }

          .desc {
            padding-left: 0.1rem;
            padding-bottom: 0.1rem;
            font-size: 0.13rem;
            font-weight: 400;
            color: #8f8f8f;
          }

          .info-list {
            flex: 1;
          }

          .device-info {
            width: 6.41rem;
            border-radius: 0.06rem;
            border: 1px solid #f2f2f2;
            margin-top: 0.16rem;
            padding-bottom: 0.2rem;

            .device-head {
              width: 100%;
              background: #fff3ec;
              border-radius: 0.03rem;
              border: 1px solid #ffebdf;
              font-size: 0.16rem;
              color: #000;
              padding: 0.15rem 0.14rem;
              box-sizing: border-box;

              .device-tit {
                line-height: 0.14rem;
                border-left: 0.04rem solid #ff5400;
                padding: 0 0.1rem;
                font-weight: bold;
                color: #000000;
              }
            }

            .device-list {
              font-size: 0;

              .device-item {
                width: 50%;
                font-size: 0.14rem;
                font-weight: 400;
                color: #333333;
                padding: 0.2rem 0 0;
                display: inline-block;

                .item-tit {
                  width: 1.14rem;
                  text-align: right;
                  padding-right: 0.14rem;
                  font-size: 0.14rem;
                  color: #aaaaaa;
                  display: inline-block;
                }
              }
            }
          }
        }
      }

      .card-tit {
        padding: 0.22rem 0.33rem;
        font-weight: bold;
        font-size: 0.18rem;
        color: #000000;
      }

      .btnGroup {
        display: flex;
        padding: 0.4rem 0 0.18rem;
        justify-content: center;

        .btn {
          width: 1.38rem;
          background: #686868;
          border-radius: 0.09rem;
          text-align: center;
          font-size: 0.14rem;
          color: #ffffff;
          padding: 0.1rem 0;
          line-height: 0.2rem;
          cursor: pointer;
        }

        .cancelBtn {
          background: #ffffff;
          border: 1px solid #686868;
          margin-left: 0.38rem;
          color: #686868;
        }
      }

      .list {
        font-size: 0;
        border-bottom: 1px solid #e6e6e6;
        padding-bottom: 0.15rem;

        &.bottom {
          border: unset;
          padding-top: 0.22rem;
        }

        .item {
          padding: 0 0.07rem 0 0.35rem;
          font-size: 0.14rem;
          color: #000;
          display: inline-block;
          padding-bottom: 0.22rem;

          &.tit {
            font-weight: bold;
          }

          .item-tit {
            color: #8e8e8e;
          }
        }
      }

      // 选择支付
      .choose-box {
        padding: 0.2rem 0;
        width: 14.59rem;
        margin: 0 auto 0.1rem;
        box-sizing: border-box;
        display: flex;
        border-bottom: 1px solid #e6e6e6;

        .choose-item {
          font-size: 0;
          margin-right: 1.32rem;
          display: inline-block;

          .chooseImg {
            width: 150px;
            height: 200px;
            border: 1px solid #8e8e8e;
          }

          .choose-tit {
            padding-top: 0.1rem;
            font-size: 0.13rem;
            color: #000000;
            text-align: center;
          }
        }
      }

      .choose-uploader {
        width: 1.44rem;
        height: 1.44rem;
        background: #f8f8f8;
        border-radius: 0.08rem;
        border: 1px solid #cfd3da;
        margin-left: 0.33rem;
        font-size: 0.14rem;
        color: #363636;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        .uplodImg {
          width: 100px;
          height: 100px;
        }

        .add {
          font-size: 0.13rem;
          margin-top: 0.14rem;
        }
      }

      // 评价
      .evaluate-box {
        padding: 0.2rem 0.3rem 1rem;
        box-sizing: border-box;
        display: flex;
        position: relative;

        .userImg {
          width: 0.44rem;
          height: 0.44rem;
          border-radius: 50%;
          margin: 0 0.3rem 0 0.1rem;
        }

        /deep/ .el-textarea {
          height: 1.53rem;
          width: 4rem;
        }

        /deep/ .el-textarea__inner {
          background: #f6f6f6;
          border: 1px solid #f6f6f6;
          font-size: 0.14rem;
          height: 1.53rem;
        }

        .upload-box {
          margin: 0 0.16rem;
          width: 4rem;
          background: #ffffff;
          border-radius: 0.06rem;
          border: 1px solid #eeeeee;
          padding: 0.12rem 0.14rem;
          box-sizing: border-box;

          .upload-add {
            font-size: 0.14rem;
            color: #8f8f8f;
            margin-bottom: 0.1rem;
          }

          /deep/ .el-upload--picture-card {
            background-color: #fbfdff;
            border: 1px dashed #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            width: 100px;
            height: 100px;
            cursor: pointer;
            line-height: 55px;
            vertical-align: top;
          }

          /deep/ .el-upload-list__item {
            width: 100px;
            height: 100px;
          }

          .avatar-uploader {
            width: 0.73rem;
            height: 0.73rem;
            background: #efefef;
            border-radius: 0.06rem;
            font-size: 0.13rem;
            text-align: center;
            padding-top: 0.24rem;
            box-sizing: border-box;
            color: #727272;
          }
        }

        .score-box {
          flex: 1;
          padding-left: 1rem;
          box-sizing: border-box;
          font-size: 0;

          .score-tit {
            font-size: 0.16rem;
            color: #000000;
            padding-bottom: 0.24rem;
          }

          .score-line {
            img {
              width: 0.3rem;
              height: 0.3rem;
              margin-right: 0.2rem;
            }
          }
        }

        .scoreBtn {
          width: 1.38rem;
          background: #686868;
          border-radius: 0.09rem;
          position: absolute;
          bottom: 0rem;
          right: 0.44rem;
          text-align: center;
          font-size: 0.14rem;
          color: #ffffff;
          padding: 0.1rem 0;
          line-height: 0.2rem;
        }

        &.evaluate-item {
          display: block;
          padding: 0.2rem 0 0.1rem;
          border-bottom: 1px solid #f3f3f3;

          &:last-child {
            border-bottom: unset;
          }

          .user-line {
            width: 100%;

            .user-name {
              font-size: 0.14rem;
              color: #000;
              padding-right: 0.29rem;
            }

            .score-line {
              flex: 1;
              font-size: 0;

              img {
                margin: 0 0.05rem;
                width: 0.16rem;
                height: 0.16rem;
              }
            }
          }

          .evaluate {
            padding: 0.2rem 0.88rem;
            box-sizing: border-box;
            font-size: 0.14rem;
            color: #000000;
          }

          .imgs {
            padding-left: 0.88rem;
            box-sizing: border-box;
            font-size: 0;

            .evaluate-img {
              width: 0.78rem;
              height: 0.78rem;
              margin-right: 0.13rem;
              margin-bottom: 0.1rem;
            }
          }
        }
      }

      .evaluate-lists {
        padding: 0 0.3rem;
        box-sizing: border-box;

        .device-box {
          background: #f5f5f5;
          border-radius: 0.06rem;
          padding: 0.17rem 0.88rem;
          box-sizing: border-box;
          font-size: 0;
          margin-bottom: 0.11rem;

          .device-img {
            width: 0.82rem;
            height: 0.82rem;
            margin-right: 0.14rem;
          }

          .price {
            color: #7c7c7c;
            font-size: 0.14rem;
            padding-top: 0.17rem;

            span {
              font-size: 0.16rem;
              font-weight: bold;
              color: #ff4141;
              padding-left: 0.05rem;
            }
          }
        }
      }

      // 申请终止
      &.stopCard {
        .evaluate-box {
          padding-bottom: 0rem;
          padding-top: 0rem;

          /deep/ .el-textarea {
            width: 100%;
          }
        }

        .scoreBtn {
          position: unset;
        }
      }

      // 订单信息
      &.order-card {
        position: relative;

        .detailBtn {
          position: absolute;
          right: 0.33rem;
          top: 0.13rem;
        }

        .list {
          border-top: 1px solid #e9e9e9;
          border-bottom: unset;
          padding: 0.2rem 0.33rem 0.1rem;
          box-sizing: border-box;

          .item {
            width: 33%;
            padding-left: 0;
            box-sizing: border-box;

            &.tit {
              display: block;
            }

            &.line {
              display: block;
            }

            &.price {
              font-size: 0.12rem;
              color: #a0a0a0;

              .num {
                color: #ff5858;
              }

              .item-tit {
                color: #979797;
              }
            }
          }

          .item-tit {
            color: #8d8d8d;
          }
        }
      }

      // 附件合同
      .file-warn {
        padding: 0 0.33rem 0.22rem;
        font-size: 0.13rem;
        color: #ff7878;
      }

      &.file-card {
        padding-bottom: 0.22rem;

        .file-box {
          padding: 0 0.33rem;
          box-sizing: border-box;
          display: flex;
          align-items: center;

          .pdfIcon {
            width: 0.44rem;
            height: 0.48rem;
            margin-right: 0.05rem;
          }

          .file-name {
            font-size: 0.13rem;
            color: #000000;
            padding-bottom: 0.12rem;
            padding-left: 0.08rem;

            .type {
              color: #ff6332;
            }
          }

          .file-date {
            font-size: 0.13rem;
            color: #bdbdbd;
          }
        }

        .download {
          min-width: 0.6rem;
          width: 0.6rem;
          margin: 0.2rem 0.33rem 0;
          background: #ffffff;
          border-radius: 0.04rem;
          color: #ff7531;
          font-size: 0.13rem;
          border: 1px solid rgba(255, 84, 0, 0.15);
        }
      }

      // 支付信息
      .pay-box {
        padding: 0 0.2rem;
        box-sizing: border-box;
        font-size: 0;

        .pay-item {
          padding-bottom: 0.2rem;
          width: 1.6rem;
          text-align: center;
          display: inline-block;

          .pay-tit {
            padding: 0.12rem 0 0.08rem;
            font-size: 0.13rem;
            color: #333333;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .pay-desc {
            font-size: 0.13rem;
            color: #989898;
          }
        }

        .fileImg {
          width: 1.33rem;
          height: 1.33rem;
          margin: 0 auto;
        }
      }

      // 方案内容
      .info-pro {
        padding: 0.1rem 0.24rem 0.26rem 0.37rem;

        .pro-tit {
          font-weight: bold;
          font-size: 0.16rem;
          color: #000;
        }

        .pro-box {
          background: #f9f9f9;
          margin: 0.26rem 0 0 0.05rem;
          min-height: 0.96rem;
          background: #f9f9f9;
          border-radius: 0.06rem;
          padding: 0.1rem;
          box-sizing: border-box;
          font-size: 0;
          display: flex;
          flex-wrap: wrap;

          .pro-item {
            display: inline-block;
            font-size: 0.14rem;
            padding: 0.1rem 0.2rem;
            box-sizing: border-box;
            color: #333;

            .item-tit {
              padding-right: 0.12rem;
              color: #727272;
            }
          }
        }
      }
    }
  }
}

// 续费信息
.renew-box {
  padding: 0.1rem 0.33rem 0.2rem;
  font-size: 0;
  display: flex;
  align-items: center;

  .num-box {
    padding-left: 0.5rem;
    height: 0.82rem;
    width: 2.24;

    .num-tit {
      font-size: 0.14rem;
      color: #000000;
      padding-bottom: 0.12rem;

      .num-one {
        color: #ff5050;
      }
    }

    /deep/ .el-input__inner {
      background: #fafafa;
      padding: 0.1rem 0.08rem;
      line-height: 0.2rem;
      height: auto;
      text-align: center;
      color: #000;
      font-size: 0.14rem;
      border-radius: 0.04rem;
      border: 1px solid #ededed;
    }
  }

  .renew-item {
    display: inline-block;
    min-width: 1.6rem;
    height: 0.82rem;
    border-radius: 0.06rem;
    padding: 0.1rem 0.13rem 0 0.13rem;
    box-sizing: border-box;
    margin-right: 0.27rem;
    background: #fafafa;
    border: 1px solid #ededed;
    color: #8f8f8f;

    &.active {
      color: #ff8e4f;
      background: #fff5ef;
      position: relative;
      overflow: hidden;
      border: 1px solid #ff8e4f;

      &::after {
        content: "";
        position: absolute;
        width: 0.24rem;
        height: 0.24rem;
        right: 0;
        bottom: 0;
        background: #ff8e4f;
        border-radius: 2rem 0 0;
      }

      .active-icon {
        position: absolute;
        bottom: 0rem;
        right: 0rem;
        color: #fff;
        z-index: 99;
        font-size: 0.12rem;
      }
    }

    .month {
      padding-bottom: 0.08rem;
      line-height: 0.22rem;
      font-size: 0.16rem;
      font-weight: 400;
    }

    .renew {
      font-size: 0.12rem;
      line-height: 0.2rem;
    }
  }
}
</style>
